import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const summaryHeaderClassName = css({
  alignItems: 'flex-start',
  display: 'flex',
});

export const mediaClassName = css({
  background:
    'linear-gradient(to bottom right, #91d8fc, #b164e0 50%, #e64f6e 75%, #ff333e 95%)',
  borderRadius: 100,
  padding: 14,
});

export const iconClassName = css({
  color: 'rgba(255, 255, 255, 1)',
  '& svg': {
    height: 22,
    width: 22,
  },
});

export const headerClassName = css({
  marginLeft: Spacing.MD,
});

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.LARGE,
  fontWeight: FontWeight.BOLD,
});

export const subheadingClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.NORMAL,
  marginTop: Spacing['2XS'],
});

export const summaryPriceClassName = css({
  display: 'flex',
  flexDirection: 'column',
  marginTop: Spacing.LG,
});

export const priceWrapperClassName = css({
  alignItems: 'center',
  display: 'flex',
  position: 'relative',
});

export const priceSignClassName = css({
  position: 'absolute',
  top: 0,
  left: 0,
  fontSize: 22,
  fontWeight: FontWeight.BOLD,
});

export const priceValueClassName = css({
  fontSize: 48,
  fontWeight: FontWeight.BOLD,
  lineHeight: 1,
  marginLeft: Spacing.MD,
  marginTop: Spacing['2XS'],
});

export const priceLabelClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
  marginTop: Spacing.SM,
});

export const summaryBodyClassName = css({
  marginTop: 28,
});

export const listClassName = css({
  margin: 0,
  padding: 0,
  li: {
    display: 'block',
    marginBottom: 18,
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
});

export const benefitItemClassName = css({
  alignItems: 'center',
  display: 'flex',
});

export const benefitIconWrapperClassName = css({
  background: Colors.Brand,
  borderRadius: 100,
  padding: Spacing['2XS'],
});

export const benefitIconClassName = css({
  color: Colors.White,
  height: 11,
  width: 11,
});

export const benefitLabelClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
  marginLeft: Spacing.SM,
});

export const summaryFooterClassName = css({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 28,
});

export const footerLabelClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
});

export const footerLinkWrapperClassName = css({
  marginTop: Spacing['2XS'],
});

export const footerLinkClassName = css({
  color: Colors.Brand,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
  '&:hover': {
    textDecoration: 'underline',
  },
});
